import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'

type Entry = {
  id: string
  userId: string | null
  userEmail: string | null
  action: string
  resource: string
  resourceId: string | null
  details: unknown
  ipAddress: string | null
  createdAt: string
}

export default function AdminAuditPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'audit'],
    queryFn: async () =>
      (await apiClient.get<{ data: Entry[]; meta: { total: number } }>('/api/v1/admin/audit')).data,
  })

  if (isLoading) return <p className="text-sm text-neutral-500">Loading…</p>

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">Audit log</h1>
        <p className="text-sm text-neutral-500">{data?.meta.total ?? 0} entries</p>
      </div>
      <div className="rounded border bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-neutral-500 border-b">
            <tr>
              <th className="px-3 py-2">When</th>
              <th className="px-3 py-2">Action</th>
              <th className="px-3 py-2">Resource</th>
              <th className="px-3 py-2">User</th>
              <th className="px-3 py-2">IP</th>
            </tr>
          </thead>
          <tbody>
            {(data?.data ?? []).map((e) => (
              <tr key={e.id} className="border-b">
                <td className="px-3 py-2 text-neutral-500 whitespace-nowrap">
                  {new Date(e.createdAt).toLocaleString()}
                </td>
                <td className="px-3 py-2 font-mono text-xs">{e.action}</td>
                <td className="px-3 py-2 text-neutral-600">
                  {e.resource}
                  {e.resourceId ? ` / ${e.resourceId.slice(0, 8)}` : ''}
                </td>
                <td className="px-3 py-2 text-neutral-600">{e.userEmail ?? '—'}</td>
                <td className="px-3 py-2 text-neutral-500">{e.ipAddress ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
